<h3 class="card-header">{{ "REGISTER" | translate }}</h3>
<div class="card-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-group col-5">
        <label>{{ "REGISTER_FIRST_NAME" | translate }}</label>
        <input
          type="text"
          formControlName="first_name"
          class="form-control field"
          [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }"
        />
        <div *ngIf="submitted && f.first_name.errors" class="invalid-feedback">
          <div *ngIf="f.first_name.errors.required">
            {{ "REGISTER_MSG_REQUIRED_FIRST_NAME" | translate }}
          </div>
        </div>
      </div>
      <div class="form-group col-5">
        <label>{{ "REGISTER_LAST_NAME" | translate }}</label>
        <input
          type="text"
          formControlName="last_name"
          class="form-control field"
          [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }"
        />
        <div *ngIf="submitted && f.last_name.errors" class="invalid-feedback">
          <div *ngIf="f.last_name.errors.required">
            {{ "REGISTER_MSG_REQUIRED_LAST_NAME" | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-6">
        <div class="form-group">
          <label>{{ "REGISTER_SEX" | translate }}</label>
          <select
            formControlName="sex"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.sex.errors }"
          >
            <option value="" disabled selected hidden></option>
            <option>{{ "REGISTER_MALE" | translate }}</option>
            <option>{{ "REGISTER_FEMALE" | translate }}</option>
          </select>
          <div *ngIf="submitted && f.sex.errors" class="invalid-feedback">
            <div *ngIf="f.sex.errors.required">
              {{ "REGISTER_MSG_REQUIRED_SEX" | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="form-group">
          <label>{{ "REGISTER_DATE_BIRTH" | translate }}</label>
          <input
            type="date"
            max="202-04-24"
            formControlName="dob"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.dob.errors }"
          />
          <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
            <div *ngIf="f.dob.errors.required">
              {{ "REGISTER_MSG_REQUIRED_DOB" | translate }}
            </div>
          </div>
          <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
            <div *ngIf="f.dob.errors.dateLessThan">
              {{ "REGISTER_MSG_DOB_PAST" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="form-row">
<div class="col-6">
                    <div class="form-group">
                        <label>Height (in feet)</label>
                        <input type="number" formControlName="height" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.height.errors }" />
                        <div *ngIf="submitted && f.height.errors" class="invalid-feedback">
                            <div *ngIf="f.height.errors.required">Field is required</div>
                        </div>
                    </div>
                </div>

              

                <div class="col-6">
                    <div class="form-group">
                        <label>Weight (in pounds)</label>
                        <input type="number" formControlName="weight" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.weight.errors }" />
                        <div *ngIf="submitted && f.weight.errors" class="invalid-feedback">
                            <div *ngIf="f.weight.errors.required">Field is required</div>
                        </div>
                    </div>
                </div>
</div>-->
    <div class="form-group">
      <label>{{ "REGISTER_EMAIL" | translate }}</label>
      <input
        type="text"
        formControlName="email"
        class="form-control field"
        [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
      />
      <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
        <div *ngIf="f.email.errors.required">
          {{ "REGISTER_MSG_REQUIRED_EMAIL" | translate }}
        </div>
        <div *ngIf="f.email.errors.email">
          {{ "REGISTER_MSG_VALID_EMAIL" | translate }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <button
        type="button"
        class="btn btn-primary"
        (click)="sendCode()"
        [disabled]="f.email.invalid"
      >
        {{ "REGISTER_BTN_CODE" | translate }}
      </button>
      <div
        *ngIf="message"
        class="alert alert-info mt-2"
        [innerHTML]="message"
      ></div>
    </div>

    <div class="form-group">
      <label>{{ "REGISTER_VERIFICATION_CODE" | translate }}</label>
      <input
        type="text"
        formControlName="code"
        class="form-control field"
        [ngClass]="{ 'is-invalid': submitted && f.code.errors }"
      />
      <div *ngIf="submitted && f.code.errors" class="invalid-feedback">
        <div *ngIf="f.code.errors.required">
          {{ "REGISTER_MSG_REQUIRED_CODE" | translate }}
        </div>
        <div *ngIf="f.code.errors.minlength">
          {{ "REGISTER_MSG_CODE_6" | translate }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>{{ "REGISTER_MOBILE" | translate }}</label>
      <input
        type="text"
        formControlName="mobile"
        class="form-control field"
        [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }"
      />
      <div *ngIf="submitted && f.code.errors" class="invalid-feedback">
        <div *ngIf="f.mobile.errors.required">
          {{ "REGISTER_MSG_REQUIRED_PHONE" | translate }}
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col">
        <label>{{ "REGISTER_PASSWORD" | translate }}</label>
        <input
          type="password"
          formControlName="password"
          class="form-control field"
          [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
        />
        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
          <div *ngIf="f.password.errors.required">
            {{ "REGISTER_MSG_REQUIRED_PASSWORD" | translate }}
          </div>
          <div *ngIf="f.password.errors.minlength">
            {{ "REGISTER_MSG_PASSWORD_8" | translate }}
          </div>
          <div *ngIf="f.password.errors.passwordComplexity">
            {{ "REGISTER_MSG_PASSWORD_COMPLEXITY" | translate }}
          </div>
        </div>
      </div>
      <div class="form-group col">
        <label>{{ "REGISTER_CONFIRM_PASSWORD" | translate }}</label>
        <input
          type="password"
          formControlName="confirmPassword"
          class="form-control field"
          [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }"
        />
        <div
          *ngIf="submitted && f.confirmPassword.errors"
          class="invalid-feedback"
        >
          <div *ngIf="f.confirmPassword.errors.required">
            {{ "REGISTER_MSG_CONFIRM_PASSWORD" | translate }}
          </div>
          <div *ngIf="f.confirmPassword.errors.mustMatch">
            {{ "REGISTER_MSG_PASSWORD_NOT_MATCH" | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group" style="margin-left: 1%">
        <label>{{ "REGISTER_REFERRAL_QUESTION" | translate }}</label>
        <select
          formControlName="referralSource"
          class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f.referralSource.errors }"
          (change)="onReferralSourceChange()"
        >
          <option value="" disabled selected hidden></option>
          <option value="advertisement">
            {{ "REGISTER_REFERRAL_AD" | translate }}
          </option>
          <option value="tranqSleepWebsite">
            {{ "REGISTER_REFERRAL_TRANQSLEEP" | translate }}
          </option>
          <option value="doctorRecommendation">
            {{ "REGISTER_REFERRAL_DOCTOR" | translate }}
          </option>
          <option value="friendIntroduction">
            {{ "REGISTER_REFERRAL_FRIEND" | translate }}
          </option>
          <option value="other">
            {{ "REGISTER_REFERRAL_OTHER" | translate }}
          </option>
        </select>
        <div
          *ngIf="submitted && f.referralSource.errors"
          class="invalid-feedback"
        >
          <div *ngIf="f.referralSource.errors.required">
            {{ "REGISTER_MSG_REQUIRED_REFERRAL" | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="isOtherSelected">
      <label>{{ "REGISTER_REFERRAL_SPECIFY" | translate }}</label>
      <input
        type="text"
        formControlName="otherDetails"
        class="form-control field"
      />
    </div>
    <div class="form-group form-check">
      <input
        type="checkbox"
        formControlName="acceptTerms"
        id="acceptTerms"
        class="form-check-input"
        [ngClass]="{ 'is-invalid': submitted && f.acceptTerms.errors }"
      />
      <label for="acceptTerms" class="form-check-label"
        >{{ "REGISTER_ACCEPT" | translate }}
        <a
          href="https://mysleeptutor.com/terms.html"
          target="_blank"
          style="color: blue"
          >{{ "REGISTER_TERMS" | translate }}</a
        ></label
      >
      <div *ngIf="submitted && f.acceptTerms.errors" class="invalid-feedback">
        {{ "REGISTER_MSG_REQUIRED_TERMS" | translate }}
      </div>
    </div>
    <div class="form-group">
      <button [disabled]="loading" class="btn btn-primary field">
        <span
          *ngIf="loading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        {{ "REGISTER" | translate }}
      </button>
      <a routerLink="../login" href="" class="btn btn-link">{{
        "REGISTER_CANCEL" | translate
      }}</a>
    </div>
  </form>
  <div *ngIf="errorMessage" class="error">
    {{ errorMessage }}
  </div>
</div>
